export default __webpack_public_path__ + "static/media/buttonimage.e4243c04.svg";